import * as React from 'react'
import * as styles from './App.scss'
import { theme } from './theme/theme'
import { ThemeProvider } from 'styled-components'
import { GlobalStyle } from './theme/globalStyle'
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom'
import { Layout } from './components/components'
import { FrontPage, PageNotFound } from './pages/pages'
import AppConsentProvider from './appConsentContext'
import { useCookieConsent } from './utils/customHooks'
import { useEffect } from 'react'

// import fonts
import { MainPage } from './pages/mainPage'
import AudioProvider from './audioContext'
import i18n from 'i18next'

export const publicFilesLastCacheToken = '202212221101'

// console.log('mode: ', process.env.MODE)
console.log('Welcome to Audioguide Stephansdom!' + ((process.env.MODE === 'development') ? ' The code is built with settings for the DEV System. ' : ''))
const ProtectedRoute = ({ children }) => {
  const { acceptedTerms } = useCookieConsent()
  const location = useLocation()
  if (!acceptedTerms) {
    return <Navigate to="/" replace state={{ from: location }} />
  }
  return children
}

const CorrectStationUrlRoute = ({ }) => {
  const { id } = useParams()
  return <Navigate to={`/${i18n.resolvedLanguage}/station/${id}`} />
}

const App = (): React.ReactNode => {
  //Documentation: https://blog.webdevsimplified.com/2022-07/react-router/
  /* className={styles.root} no longer works with style-loader version >= 3.0.0 with esModule enabled */
  useEffect(() => {
    const syncDocumentLanguage = (language?: string) => {
      document.documentElement.lang = language || 'en'

      // document.title = title doesnt change
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      )
      metaDescription.setAttribute('content', i18n.t('frontpage.metaDescription'))
      const ogDescription = document.querySelector(
        'meta[property="og:description"]'
      )
      ogDescription.setAttribute(
        'content',
        i18n.t('frontpage.metaDescription')
      )
    }

    syncDocumentLanguage(i18n.resolvedLanguage)
    i18n.on('languageChanged', syncDocumentLanguage)

    return () => {
      i18n.off('languageChanged', syncDocumentLanguage)
    }
  }, [])

  return (
    <AudioProvider>
      <ThemeProvider theme={theme}>
        <div className={styles.root}>
          <GlobalStyle />
          <BrowserRouter>
            <AppConsentProvider>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<FrontPage />} />
                  <Route path="/station/:id" element={<CorrectStationUrlRoute />} />
                  <Route path=":lang/">
                    <Route index element={<FrontPage />} />

                    <Route
                      path="station"
                      element={
                        <ProtectedRoute>
                          <MainPage />
                        </ProtectedRoute>
                      }
                    >
                      <Route
                        path=":id"
                        element={
                          <ProtectedRoute>
                            <MainPage />
                          </ProtectedRoute>
                        }
                      />
                    </Route>

                    {/* Using path="*"" means "match anything", so this route
                    acts like a catch-all for URLs that we don't have explicit
                    routes for. */}
                  </Route>
                </Route>
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </AppConsentProvider>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </AudioProvider>
  )
}

export default App
